import { render } from "./IndustryInformation.vue?vue&type=template&id=b32c27f2&scoped=true"
import script from "./IndustryInformation.vue?vue&type=script&lang=js"
export * from "./IndustryInformation.vue?vue&type=script&lang=js"

import "./IndustryInformation.vue?vue&type=style&index=0&id=b32c27f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_0b0c69fa16feb22e92fe2dae88baf76f/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b32c27f2"]])

export default __exports__